module.exports = __webpack_public_path__ + "img/trip.900be763.png";